export const deepClone = (original: genericObject) => {
  if (typeof original !== 'object' || original === null) {
    return original; // Return the value if original is not an object
  }

  let clone: any;
  // Create an array or object to hold the values
  if (Array.isArray(original)) {
    clone = [];
    original.forEach((value: any, index: number) => {
      clone[index] = deepClone(value);
    });
  } else {
    clone = {};
    Object.entries(original).forEach(([key, value]) => {
      clone[key] = deepClone(value);
    });
  }
  return clone;
};

export const retrieveNestedValue = (
  name: string | string[],
  data?: genericObject,
): any => {
  if (!data) return undefined;
  if (Array.isArray(name)) return name.map((n) => retrieveNestedValue(n, data));
  return name.split('.').reduce((prev: genericObject, curr: string) => {
    return typeof prev === 'object' ? prev[curr] : undefined;
  }, data);
};

export const setNestedValue = (
  name: string | string[],
  data: genericObject,
  value: any,
): any => {
  let local = data;
  if (Array.isArray(name)) {
    name.forEach((n, index) => {
      local = setNestedValue(n, local, value[index]);
    });
    return local;
  }
  const keys = name.split('.');
  const key = keys[0];
  if (keys.length === 1) local[key] = value;
  else local[key] = setNestedValue(keys.slice(1).join('.'), local[key], value);
  return local;
};

export function flatStateReducer<T>(state: T, payload: T): T {
  if (payload === null || Object.keys(payload).length === 0)
    return { ...state };
  return { ...state, ...payload };
}

export function nestedStateReducer<T>(state: T, payload: T): T {
  if (payload === null || Object.keys(payload).length === 0)
    return { ...state };
  return deepClone(payload);
}
